import { QueryParameter } from '@/shared/constants/queryParams';
import { useAutoOpenPaymentWidgetParams } from '@/shared/hooks/useAutoOpenPaymentWidgetParams';
import { useIsPaymentManagerOpened } from '@/shared/hooks/useIsPaymentManagerOpened';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export const useRestrictedForNotification = () => {
    const searchParams = useSearchParams();
    const { shouldOpenWidgetFromQuery } = useAutoOpenPaymentWidgetParams();
    const isPaymentManagerVisible = useIsPaymentManagerOpened();
    const isWatch = searchParams.has(QueryParameter.WATCH);

    return isWatch || shouldOpenWidgetFromQuery || isPaymentManagerVisible;
};
